import LessonEditor from 'screens/LessonEditor';

const NewLessonEditor = () => <LessonEditor isNewLesson={true} />;

export default NewLessonEditor;
